if (!customElements.get('hp-customer-reviews')) {
  customElements.define('hp-customer-reviews', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-review-direction]');
        if (button) this.querySelector(button.dataset.reviewDirection === 'next' ? '.jdgm-carousel__right-arrow' : '.jdgm-carousel__left-arrow')?.click();
      }, { signal: this.controller.signal });
      this.widgetObserver = new MutationObserver(() => this.connectControls());
      this.widgetObserver.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      this.connectControls();
      this.addEventListener('keydown', event => {
        if (event.target !== this.querySelector('.hp-reviews__highlights') || event.altKey || event.ctrlKey || event.metaKey) return;
        const selector = { ArrowLeft: '.jdgm-carousel__left-arrow', ArrowRight: '.jdgm-carousel__right-arrow' }[event.key];
        if (!selector) return;
        const button = this.querySelector(selector);
        if (button) { event.preventDefault(); button.click(); }
      }, { signal: this.controller.signal });
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.loadTrustpilot();
      }, { rootMargin: '400px' });
      this.observer.observe(this);
    }

    connectControls() {
      const widget = this.querySelector('.jdgm-carousel--done');
      if (!widget || !widget.querySelector('.jdgm-carousel__right-arrow')) return;
      this.querySelector('.hp-reviews__controls').hidden = false;
      this.setAttribute('data-controls-ready', '');
      this.widgetObserver.disconnect();
      window.dispatchEvent(new Event('resize'));
    }

    loadTrustpilot(attempt = 0) {
      if (!this.isConnected) return;
      if (window.Trustpilot?.loadFromElement) {
        this.querySelectorAll('.trustpilot-widget').forEach(widget => {
          if (!widget.querySelector('iframe')) window.Trustpilot.loadFromElement(widget, true);
        });
        return;
      }
      if (!document.querySelector('script[src*="widget.trustpilot.com/bootstrap/"]')) {
        const script = document.createElement('script');
        script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
        script.async = true;
        document.head.append(script);
      }
      if (attempt < 20) this.timer = setTimeout(() => this.loadTrustpilot(attempt + 1), 500);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.widgetObserver?.disconnect();
      clearTimeout(this.timer);
    }
  });
}
